import React, { useState, useEffect } from 'react';
import { GENERATING_MESSAGES, SAVING_MESSAGES } from '../../utils/constants';
import dubaiPoliceLogo from '../../assets/dubai-police-logo.png';

const LoadingScreen = ({ type = 'generating' }) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const messages = type === 'saving' ? SAVING_MESSAGES : GENERATING_MESSAGES;

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div className="h-screen relative overflow-hidden bg-gradient-to-b from-[#E4EFEA] via-[#D1DDD7] to-[#B8CFC4]">
      {/* Vertical spine */}
      <div className="forensic-spine" />

      {/* Background layers */}
      <div className="forensic-grid-overlay opacity-25" />
      <div className="forensic-data-stream absolute inset-0 opacity-30" />
      <div className="forensic-digital-noise" />

      {/* Circuit lines */}
      <div className="absolute left-0 top-1/3 w-40 h-[2px] bg-gradient-to-r from-[#0e734b] to-transparent" />
      <div className="absolute right-0 top-2/3 w-32 h-[2px] bg-gradient-to-l from-[#0e734b] to-transparent" />

      {/* Green blocks */}
      <div className="forensic-block forensic-block-1" />
      <div className="forensic-block forensic-block-2" />
      <div className="forensic-corner-tl" />

      {/* Main content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-8 text-center gap-8">
        {/* Logo */}
        <img src={dubaiPoliceLogo} alt="Dubai Police" className="h-14 w-auto" />

        {/* Status text - Bilingual */}
        <div className="space-y-3">
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#0e734b] font-tagline">
            {type === 'saving' ? 'Saving Evidence' : 'AI Processing'}
          </p>

          {/* Arabic status */}
          <p className="text-xl text-[#0e734b] font-arabic font-bold" dir="rtl">
            {type === 'saving' ? 'جاري حفظ الأدلة...' : 'جاري المعالجة بالذكاء الاصطناعي...'}
          </p>

          {/* Main message */}
          <h1 className="text-4xl font-title uppercase text-[#1A1A1A] max-w-xl">
            {messages[messageIndex]}
          </h1>

          {/* Subtitle */}
          <p className="text-[#4A5550] text-base font-title-light">
            {type === 'saving'
              ? 'Securing evidence to the forensic archive...'
              : 'Dubai Police AI is processing your image...'}
          </p>
        </div>

        {/* Loading spinner - forensic style */}
        <div className="relative w-40 h-40">
          {/* Outer ring */}
          <div className="absolute inset-0 border-4 border-[#D1DDD7] rounded-sharp" />

          {/* Spinning segment */}
          <div className="absolute inset-0 border-4 border-transparent border-t-[#0e734b] border-r-[#0e734b] rounded-sharp animate-spin" />

          {/* Inner ring */}
          <div className="absolute inset-4 border-2 border-[#D1DDD7] rounded-sharp" />

          {/* Inner spinning segment - slower */}
          <div className="absolute inset-4 border-2 border-transparent border-t-[#0e734b] rounded-sharp animate-spin-slow" />

          {/* Center content */}
          <div className="absolute inset-8 bg-white/80 rounded-sharp flex items-center justify-center">
            <span className="text-xl font-title text-[#0e734b]">AI</span>
          </div>
        </div>

        {/* Progress dots */}
        <div className="flex items-center gap-3">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className="w-3 h-3 bg-[#0e734b] rounded-sharp animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>

        {/* Status indicator - Bilingual */}
        <div className="flex items-center gap-2 text-[#6B7770] text-[10px] uppercase tracking-[0.2em]">
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm animate-pulse" />
          <span className="font-title-light">Processing</span>
          <span className="font-arabic">— يرجى الانتظار</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
